import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
//Import Custom Services Here
import * as moment from "moment";

@Component({
	templateUrl: "./report-usage.component.html",
})
export class ReportUsageComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private districtschoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		DistrictSchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		SucceededID: "All",
		ReportTypeID: "All",
		GroupByID: "None",
		ShowDetailID: "No",
		OrderByID: "Complete Time",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	DistrictSchoolList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SucceededList = [
		//Insert Custom List Items Here
		{
			SucceededID: 0,
			SucceededName: "All",
		},
		{
			SucceededID: 1,
			SucceededName: "No",
		},
		{
			SucceededID: 2,
			SucceededName: "Critical Failure",
		},
		{
			SucceededID: 3,
			SucceededName: "Yes",
		},
	];

	ReportTypeList = [
		//Insert Custom List Items Here
		{
			ReportTypeID: 0,
			ReportTypeName: "All",
		},
		{
			ReportTypeID: 1,
			ReportTypeName: "System",
		},
		{
			ReportTypeID: 2,
			ReportTypeName: "Letter",
		},
		{
			ReportTypeID: 3,
			ReportTypeName: "User Report",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	GroupByList = [
		//Insert Custom List Items Here
		{
			GroupByID: 0,
			GroupByName: "None",
		},
		{
			GroupByID: 1,
			GroupByName: "Report",
		},
		{
			GroupByID: 2,
			GroupByName: "Printed By",
		},
		{
			GroupByID: 3,
			GroupByName: "Report Group",
		},
		{
			GroupByID: 4,
			GroupByName: "School",
		},
	];

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: 0,
			ShowDetailName: "No",
		},
		{
			ShowDetailID: 1,
			ShowDetailName: "Yes",
		},
	];

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: 0,
			OrderByName: "Complete Time",
		},
		{
			OrderByID: 1,
			OrderByName: "Start Date/Time",
		},
		{
			OrderByID: 2,
			OrderByName: "Title",
		},
	];

	ReportID: number = 343;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadDistrictSchoolList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.DistrictSchoolID = school.SchoolID;
			this.loadLogolist();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.DistrictSchoolID) {
		//   this.errorMessage = "Select the District School"
		//   return;
		// }

		if (!this.report.StartDate) {
			this.errorMessage = "Select the Start Date";
			return;
		}

		if (!this.report.EndDate) {
			this.errorMessage = "Select the End Date";
			return;
		}

		// if (!this.report.SucceededID) {
		//   this.errorMessage = "Select the Succeeded"
		//   return;
		// }

		// if (!this.report.ReportTypeID) {
		//   this.errorMessage = "Select the ReportType"
		//   return;
		// }

		// if (!this.report.GroupByID) {
		//   this.errorMessage = "Select the GroupBy"
		//   return;
		// }

		// if (!this.report.ShowDetailID) {
		//   this.errorMessage = "Select the ShowDetail"
		//   return;
		// }

		// if (!this.report.OrderByID) {
		//   this.errorMessage = "Select the OrderBy"
		//   return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 343;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: DistrictSchoolID
		strParam += this.report.DistrictSchoolID + "|DistrictSchoolID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: Succeeded
		strParam += "," + this.report.SucceededID + "|Succeeded";

		//Parameter 5: ReportType
		strParam += "," + this.report.ReportTypeID + "|ReportType";

		//Parameter 6: GroupBy
		strParam += "," + this.report.GroupByID + "|GroupBy";

		//Parameter 7: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 8: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 9: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
